import { _deserializable } from '../_deserializable';

export class PricelistRequest extends _deserializable {

  public customer: string;

}
